import { setSchemaOwner } from '@preset-engine/ownership/set-schema-owner.js'

export function ensureCoreSchemaOwnership(cwd: string, schemaName: string): void {
  setSchemaOwner(cwd, schemaName, 'core')
}
